import { Component, OnInit } from '@angular/core';
import { IExam, IExamCategory, UploadCandidatePassportModel } from 'src/app/interface/dto';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { CandidateService } from 'src/app/services/candidate-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-upload-candidate-passport',
  templateUrl: './upload-candidate-passport.component.html',
  styleUrls: ['./upload-candidate-passport.component.scss']
})
export class UploadCandidatePassportComponent implements OnInit {

  exam: IExam = examDefault;
  modelError = '';
  uploadCand: UploadCandidatePassportModel = {
    skipErrors: false,
    overridePreviousValues: false,
    imagePrefix: '',
    imageSuffix: '',
    specialCharacters: '',
    imageFile: undefined
  };
  categoryList: IExamCategory[] = [];
  constructor(private snackBar: SnackbarService,private candidateService: CandidateService,) { }

  ngOnInit(): void {
  }
  onFileChange(event: any) {

    if (event.target.files && event.target.files[0]) {
      this.uploadCand.imageFile = event.target.files[0];
    }
  }

  async uploadPassports() {
    let formData = new FormData();
    formData.append('imageFile', this.uploadCand.imageFile);
    formData.append('imagePrefix', this.uploadCand.imagePrefix);
    formData.append('imageSuffix', this.uploadCand.imageSuffix);
    formData.append('overridePreviousValues', '' + this.uploadCand.overridePreviousValues);
    formData.append('skipErrors', '' + this.uploadCand.skipErrors);
    formData.append('specialCharacters', this.uploadCand.specialCharacters);
    await this.candidateService.uploadPassport(formData).then(s => {
      this.snackBar.success('Upload Successfull');
    });
  }
}
